import React from 'react';
import MuiTextField from "@material-ui/core/TextField";


export const TextField = ({id, setFieldValue, sequenceNumber, error, touched, helperText, format, ...props}) => {
    return <MuiTextField fullWidth
                         id={`${id}`}
                         variant={"outlined"}
                         size={"small"}
                         error={touched && Boolean(error)}
                         helperText={error && touched ? `${helperText} - ${error}`: helperText}
                         {...props}
    />
}

export const ValiationTextField = ({id, setFieldValue, sequenceNumber, error, touched, helperText, format, ...props}) => {
    return <MuiTextField fullWidth
                         id={`${id}`}
                         variant={'standard'}
                         size={"medium"}
                         error={touched && Boolean(error)}
                         helperText={error && touched ? `${helperText} - ${error}`: helperText}
                         {...props}
    />
}